import styled from "styled-components";

import { Order } from "@sso/types";
import { PaymentGrid } from "@sso/ui/PaymentGrid";
import { Typography } from "@sso/ui/Typography";

interface UserPaymentDetailsProps {
  order: Order;
}

const UserGrid = styled(PaymentGrid)`
  width: 100%;
  gap: 1.5rem;
  padding: 0.5rem 0.2rem;
  margin-bottom: 2rem;
`;

const Title = styled.div`
  grid-column: 1;
`;

const UserHead = styled(Typography)`
  border-bottom: 1px solid #ccc;
  margin-bottom: 0.5rem;
`;

const UserPaymentDetails = ({ order }: UserPaymentDetailsProps) => {
  const { user } = order;
  return (
    <>
      <UserHead size="1.4rem">Order Summary</UserHead>
      <UserGrid>
        <Title>User:</Title>
        <p>
          {user.firstname} {user.lastname}
        </p>
        <Title>Software: </Title>
        <p>{order.softwareName}</p>
      </UserGrid>
    </>
  );
};

export default UserPaymentDetails;
